export const USER_UPDATED = "USER_UPDATED";
export const USER_SIGNEDOUT = "USER_SIGNEDOUT";
